import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockBadge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_f_44486_27757)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M43.5664 25.3203C43.5664 34.8861 35.8118 42.6406 26.2461 42.6406C16.6803 42.6406 8.92578 34.8861 8.92578 25.3203C8.92578 15.7546 16.6803 8 26.2461 8C35.8118 8 43.5664 15.7546 43.5664 25.3203Z",
				fill: "url(#paint0_linear_44486_27757)"
			})
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -11.5742,
			y: 1.9209,
			width: 60.082,
			height: 60.084,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(7px)",
					clipPath: "url(#bgblur_0_44486_27757_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_ii_44486_27757)",
			"data-figma-bg-blur-radius": 14,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M34.5098 31.9629C34.5098 40.8226 27.3275 48.0049 18.4678 48.0049C9.60803 48.0049 2.42578 40.8226 2.42578 31.9629C2.42578 23.1031 9.60803 15.9209 18.4678 15.9209C27.3275 15.9209 34.5098 23.1031 34.5098 31.9629Z",
				fill: "#F8CE98",
				fillOpacity: .5
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.1797 22.9989C18.732 22.9989 19.1797 23.4466 19.1797 23.9989V33.8339L25.2227 37.0448C25.7104 37.3039 25.8958 37.9096 25.6367 38.3973C25.3775 38.8849 24.7718 39.0704 24.2842 38.8114L18.1006 35.5262C17.5339 35.2252 17.1797 34.6357 17.1797 33.994V23.9989C17.1797 23.4466 17.6274 22.9989 18.1797 22.9989Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_44486_27757",
				x: .925781,
				y: 0,
				width: 50.6406,
				height: 50.6406,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 4,
						result: "effect1_foregroundBlur_44486_27757"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_ii_44486_27757",
				x: -11.5742,
				y: 1.9209,
				width: 60.082,
				height: 60.084,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: -4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_44486_27757"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2,
						dy: 4
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_innerShadow_44486_27757",
						result: "effect2_innerShadow_44486_27757"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_44486_27757_clip_path",
				transform: "translate(11.5742 -1.9209)",
				children: /* @__PURE__ */ _jsx("path", { d: "M34.5098 31.9629C34.5098 40.8226 27.3275 48.0049 18.4678 48.0049C9.60803 48.0049 2.42578 40.8226 2.42578 31.9629C2.42578 23.1031 9.60803 15.9209 18.4678 15.9209C27.3275 15.9209 34.5098 23.1031 34.5098 31.9629Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_44486_27757",
				x1: 11.513,
				y1: 13.5387,
				x2: 43.5664,
				y2: 42.6406,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#BF7109" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E28912"
				})]
			})
		] })
	]
});
export default SvgClockBadge;
